import type { ActiveRealmContextType } from '@interxfi/api-client/realm-context';
import type { IxmAgentauthV1AgentKeyKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const AGENT_KEY_BASE_PATH = getResolvedPath('/developer/agent-key');

export function isAgentKeysAvailable({
  activeTenantIsClearing,
  activeRealmIsSand,
}: Pick<ActiveRealmContextType, 'activeTenantIsClearing' | 'activeRealmIsSand'>) {
  return activeTenantIsClearing || activeRealmIsSand;
}

export const getAgentKeyPath: EntityPathBuilder<IxmAgentauthV1AgentKeyKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return AGENT_KEY_BASE_PATH;
    case 'detail':
      return undefined;
  }
};
